<template>

</template>

<script>
    export default {
        name: "desk"
    }
</script>

<style scoped>

</style>